import React from "react";

import Icon from "../../../../components/Icon/Icon";

import s from "./AvatarWidget.module.scss";

export default function AvatarWidget(props) {
	const { user, connect } = props;

	const { name, metamaskAccount, avatar } = user || {};

	return (
		<div className={s.root} onClick={connect} style={{cursor:'pointer'}}>
			<div className={s.accountInfo}>
				<p className={s.account}>
					{name || metamaskAccount || "no name"}
				</p>
			</div>

			<Icon icon={avatar} className={s.avatar} />
		</div>
	);
}
